import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const SensitivityScheme = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .max(80, 'Name can have a maximum of 80 characters'),
  // description: Yup.string()
  //   .required('Description is required')
  //   .max(80, 'Description can have a maximum of 80 characters'),
});

export { SensitivityScheme };
